import { Text, cssColorValue } from '@spotify-internal/encore-web';
import styled from 'styled-components';
export const Body = styled(Text).attrs({
    variant: 'bodyMedium',
    className: 'body',
}) `
  display: block;
  a {
    color: ${cssColorValue('textBase')};
    text-decoration: underline;
    &:hover:not(:focus):not(:disabled) {
      opacity: 0.8;
    }
  }
`;
